import React from 'react';
import { ArrowBigUpIcon } from 'lucide-react';
import { useAcademy } from '../../context/Academy';
import { useAcademyHub } from '../../context/AcademyHub';
interface UpvoteButtonProps {
  postId: string;
  count: number;
  compact?: boolean;
}
export function UpvoteButton({
  postId,
  count,
  compact = false
}: UpvoteButtonProps) {
  const {
    state
  } = useAcademy();
  const {
    hub,
    toggleUpvote
  } = useAcademyHub();
  const on = hub.upvoted.includes(postId);
  const disabled = !state.learner;
  return <button type="button" onClick={() => toggleUpvote(postId)} disabled={disabled} aria-pressed={on} aria-label={`${on ? 'Remove upvote' : 'Upvote'}, ${count} votes`} title={disabled ? 'Create an account to vote' : undefined} className={`flex shrink-0 items-center rounded-sm border transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-60 ${compact ? 'gap-1 px-2 py-1 text-small' : 'h-14 w-12 flex-col justify-center text-[13px]'} ${on ? 'border-gold text-gold' : 'border-line text-body hover:border-gold/60 hover:text-ink'}`} data-id="element-566" data-mp="375fi2g186r4o">
      <ArrowBigUpIcon className={compact ? 'h-4 w-4' : 'h-5 w-5'} aria-hidden="true" fill={on ? 'currentColor' : 'none'} data-id="element-567" data-mp="3s215omcjxo4p" />
      {count}
    </button>;
}